let device = "unknown";

/**
 * ref:
 * http://stackoverflow.com/questions/9847580#answer-9851769
 * http://stackoverflow.com/questions/28795476#answer-30495399
 */

try {
  const nav = window.navigator,
    ua = nav.userAgent,
    idb = !!window.indexedDB;
  if (nav.platform.substr(0, 2) === "iP") {
    //iOS (iPhone, iPod or iPad)
    // @ts-ignore
    const lte9 = /constructor/i.test(window.HTMLElement);
    // @ts-ignore
    if (ua.indexOf("Safari") !== -1 && ua.indexOf("Version") !== -1 && !nav.standalone) {
      //Safari (WKWebView/Nitro since 6+)
      device = `${nav.platform} Safari`;
    } else if ((!idb && lte9) || !window.statusbar.visible) {
      device = `${nav.platform} UIWebView`;
      // @ts-ignore
    } else if ((window.webkit && window.webkit.messageHandlers) || !lte9 || idb) {
      device = `${nav.platform} WKWebView`;
    }
  } else {
    let browser = "unknown";
    let platform = nav.platform;
    //@ts-ignore
    const isIE = !!document.documentMode;
    // @ts-ignore
    if (typeof window.InstallTrigger !== "undefined") {
      browser = "Firefox";
      //@ts-ignore
    } else if (!isIE && !!window.StyleMedia) {
      browser = "Edge";
      // @ts-ignore, Chrome 1 - 79
    } else if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
      browser = "Chrome";
    } else if (ua.indexOf("Android") !== -1) {
      platform = "Android";
      if (ua.indexOf("Chrome") !== -1) {
        browser = "Chrome";
      }
    }

    device = `${platform} ${browser}${ua.includes("wv") ? " WebView" : ""}`;
  }
} catch (error) {
  device = "unknown (error)";
}

export default device;
